import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import Hackathon from "@/pages/Hackathon";
import Environment from "@/pages/Environment";
import { Toaster } from "@/components/ui/sonner";
import AppPosthogProvider from "@/providers/PosthogProvider";
import SeoMeta from "@/components/SeoMeta";
import JoinModalProvider from "@/components/landing/JoinModalProvider";

function App() {
    return (
        <AppPosthogProvider>
            <div className="App">
                <SeoMeta />
                <JoinModalProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/events" element={<Events />} />
                            <Route path="/hackathon" element={<Hackathon />} />
                            <Route path="/environment" element={<Environment />} />
                        </Routes>
                    </BrowserRouter>
                </JoinModalProvider>
                <Toaster position="bottom-right" richColors />
            </div>
        </AppPosthogProvider>
    );
}

export default App;
